import * as React from 'react';

import * as style from './SimilarNewbuildingsWrapper.css';

interface IPSimilarNewbuildingsWrapperProps {
  children?: React.ReactNode;
}

export function SimilarNewbuildingsWrapper({ children }: IPSimilarNewbuildingsWrapperProps) {
  return (
    <div className={style['container']} data-testid="SimilarNewbuildingsWrapper">
      {children}
    </div>
  );
}
